 import React from 'react'
 import "./Home.css"
 import Product from './Product';
 function Home() {
     return (
         <div className="home">
             <img 
             className="home__image"
             src = "https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB.__CB428684220_.jpg"
             alt=""
             />
            <div className="home_row">

             <Product 
             id = "12321341"
             title="Acer Predator"
             price ={50000.96}
             rating ={5}
             image="https://images-na.ssl-images-amazon.com/images/I/81IXuyeJhYL._SX679_.jpg"


             />
             <Product 
             id = "12321341"
             title="Acer Predator"
             price ={50000.96}
             rating ={5}
             image="https://images-na.ssl-images-amazon.com/images/I/81IXuyeJhYL._SX679_.jpg"

             />
              
             </div>
           
            <div className="home_row">
            <Product 
             id = "12321341"
             title="THE LEAN STARTUP"
             price ={11.96}
             rating ={3}
             image="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Dashboard/Fuji_Dash_Deals_1x._SY304_CB430401028_.jpg"

             />
             <Product 
             id = "12321341"
             title="THE LEAN STARTUP"
             price ={11.96}
             rating ={3}
             image="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Dashboard/Fuji_Dash_Deals_1x._SY304_CB430401028_.jpg"

             />
              <Product 
             id = "12321341"
             title="THE LEAN STARTUP"
             price ={11.96}
             rating ={3}
             image="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Dashboard/Fuji_Dash_Deals_1x._SY304_CB430401028_.jpg"

             />
             
             </div> <div className="home_row">

<Product 
id = "12321341"
title="THE LEAN STARTUP"
price ={11.96}
rating ={3}
image="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Dashboard/Fuji_Dash_Deals_1x._SY304_CB430401028_.jpg"

/>
</div>
         </div>
     )
 }
 
 export default Home
 